export default "__VITE_ASSET__DRjbJfxH__"